export default __webpack_public_path__ + "static/media/mens.6b00c975.jpg";